import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const WrongPhoneNumberDialog = ({ open, onRelogin }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={2} alignItems="center" textAlign="center">
          {/* Icon */}
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              backgroundColor: "#FFF4E5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningAmberRoundedIcon sx={{ fontSize: 40, color: "#F57C00" }} />
          </Box>

          {/* Title */}
          <Typography variant="h6" fontWeight={600}>
            Incorrect Phone Number
          </Typography>

          {/* Message */}
          <Typography variant="body2" color="text.secondary">
            You are logged in with the wrong phone number.
            <br />
            Please log in again using the correct number.
          </Typography>

          {/* Button */}
          <Button
            variant="contained"
            fullWidth
            size="large"
            onClick={onRelogin}
            sx={{
              mt: 2,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Login with Correct Number
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default WrongPhoneNumberDialog;
